import HelpfulReaction from './lottie/place_emoji01_helpful.json'
import WannagoReaction from './lottie/place_emoji02_wannago.json'
import FunReaction from './lottie/place_emoji03_fun.json'
import CoolReaction from './lottie/place_emoji04_cool.json'

export const ORDERED_REACTION_TYPES = ['helpful', 'wannago', 'cool', 'fun'] as const

export const REACTION_LOTTIE_MAP = {
  ['helpful']: HelpfulReaction,
  ['wannago']: WannagoReaction,
  ['cool']: CoolReaction,
  ['fun']: FunReaction,
} as const

export type ReactionLottieType = keyof typeof REACTION_LOTTIE_MAP

export type ReactionNClickArea = {
  REACT_FIRST: string
  REACT: string
  HELPFUL: string
  WANNAGO: string
  FUN: string
  COOL: string
  REACT_LIST: string
  REACT_PROFILE: string
  REACT_FOL: string
  REACT_UNFOL: string
  EMOJITAB: string
}
